// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".2b1fe3ea068ac64fed38c9cd87bd4300a135625a.chunk.bundle.js";
};